import { useNavigate } from "react-router-dom";
import { Container, Card, Table, ButtonGroup, Button, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment/moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faReply, faClose, faMinus, faHourglass } from "@fortawesome/free-solid-svg-icons";
import { ThreeDots } from 'react-loader-spinner';
import { updateCurrentPage, getLeaveApprovalListPageByUserID, getLeaveApprovalListPageCountByUserID } from "../../3.Store/LeaveApprovalSlice";
import Pagination from "../../2.Commons/Pagination";

const LeaveApprovalList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const user = JSON.parse(localStorage.getItem("current_user"));
  const id = user?.id;
  const lists = useSelector(state => state.LeaveApprovalSlice.approvalLists);
  const currentPage = useSelector(state => state.LeaveApprovalSlice.currentPage);
  const totalPages = useSelector(state => state.LeaveApprovalSlice.totalPages);
  const role = JSON.parse(localStorage.getItem("roles"));

  console.log(lists)

  useEffect(() => {
    if (!role || !role.includes("SU-L-APPROVAL")) {  // Check required role 
      localStorage.clear(); 
      window.location.href = "/Login"; 
    }

    if (id) {
      setLoading(true);
      const fetchData = async () => {
        try {
          await dispatch(getLeaveApprovalListPageCountByUserID({ id }));
          await dispatch(getLeaveApprovalListPageByUserID({ id, page: currentPage }));
        } catch (error) {
          console.error('Error fetching leave approvals:', error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [id])

  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(getLeaveApprovalListPageByUserID({ id, page: currentPage }))
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [currentPage]);  

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleClickView = (id) => {
    navigate(`/LeaveApprovalForm/${id}`);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      dispatch(updateCurrentPage(newPage));
    };
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      dispatch(updateCurrentPage(newPage));
    };
  };

  const handlePageChange = (page) => {
    dispatch(updateCurrentPage(page));
  };

  const renderStaffList = () => {

    return lists
      .map(list => (
        <tr key={list.id} style={{ cursor: "pointer" }}>
          {isMobile ? (
            <>
              <td 
                onClick={() => handleClickView(list.id)}
                style={{ 
                  maxWidth: "200px", 
                  overflow: "hidden", 
                  whiteSpace: "nowrap", 
                  textOverflow: "ellipsis" 
                }}
              >
                <strong>
                  {list.employee.fullname
                    .toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')}
                </strong>
                <br />
                <strong>{list.leave_type.description} ({list.number_of_days}D)</strong>
                <br />
                <strong>From: </strong>{moment(list.from_date.date).format("YYYY-MM-DD")} ({list.from_ampm})
                <br />
                <strong>To: </strong>{moment(list.to_date.date).format("YYYY-MM-DD")} ({list.to_ampm})
                <br />
                <span
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,          // 👈 limit just the reason
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal"
                  }}
                >
                  {list.reason_for_application}
                </span>
              </td>
              <td className="text-center align-middle" onClick={() => handleClickView(list.id)}>
                {list.status.short_description === "APPROVED" && (
                  <FontAwesomeIcon icon={faCheck} color="#28A744" />
                )}
                {list.status.short_description === "APPROVED-HR" && (
                  <FontAwesomeIcon icon={faCheck} color="#28A744" />
                )}
                {list.status.short_description === "WITHDRAWN" && (
                  <FontAwesomeIcon icon={faReply} color="#28A744" />
                )}
                {list.status.short_description === "WITHDRAWN (HR)" && (
                  <FontAwesomeIcon icon={faReply} color="#28A744" />
                )}
                {list.status.short_description === "WITHDRAWING" && (
                  <FontAwesomeIcon icon={faReply} color="#FFC107" />
                )}
                {list.status.short_description === "REJECTED-SUPERVISOR" && (
                  <FontAwesomeIcon icon={faClose} color="#DC3545" />
                )}
                {list.status.short_description === "REJECTED-HR" && (
                  <FontAwesomeIcon icon={faClose} color="#DC3545" />
                )}
                {list.status.short_description === "DELETED" && (
                  <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                )}
                {list.status.short_description === "PENDING" && (
                  <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                )}
                {list.status.short_description === "REVERT" && (
                  <FontAwesomeIcon icon={faClose} color="#DC3545" />
                )}
              </td>
            </>
          ) : (
            <>
              <td onClick={() => handleClickView(list.id)}>{moment(list.created).format("YYYY-MM-DD")}</td>
              <td onClick={() => handleClickView(list.id)}>
                {list.employee.fullname
                  .toLowerCase()
                  .split(' ')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')}
              </td>
              <td onClick={() => handleClickView(list.id)}>{list.leave_type.description}</td>
              <td onClick={() => handleClickView(list.id)}>{list.number_of_days}</td>
              <td onClick={() => handleClickView(list.id)}>
                {moment(list.from_date.date).isSame(moment(list.to_date.date), "day") ? (
                  <>
                    {moment(list.from_date.date).format("YYYY-MM-DD")}
                    {Number(list.number_of_days) === 0.5 && ` (${list.from_ampm})`}
                  </>
                ) : (
                  // Spans multiple dates, e.g. today PM + tomorrow AM (1.0 day)
                  <>
                    {moment(list.from_date.date).format("YYYY-MM-DD")}
                    {list.from_ampm === "PM" && " (PM)"}
                    {" - "}
                    {moment(list.to_date.date).format("YYYY-MM-DD")}
                    {list.to_ampm === "AM" && " (AM)"}
                  </>
                )}
              </td>
              <td onClick={() => handleClickView(list.id)}>{list.reason_for_application}</td>
              <td className="text-center align-middle" onClick={() => handleClickView(list.id)}>
                {(list.status.short_description === "APPROVED" || list.status.short_description === "APPROVED-HR") && (
                  <FontAwesomeIcon icon={faCheck} color="#28A744" title={list.status.description}/>
                )}
                {(list.status.short_description === "WITHDRAWN" || list.status.short_description === "WITHDRAWN (HR)") && (
                  <FontAwesomeIcon icon={faReply} color="#28A744" title={list.status.description}/>
                )}
                {(list.status.short_description === "REJECTED-SUPERVISOR" || list.status.short_description === "REJECTED-HR") && (
                  <FontAwesomeIcon icon={faClose} color="#DC3545" title={list.status.description} />
                )}
                {list.status.short_description === "DELETED" && (
                  <FontAwesomeIcon icon={faMinus} color="#FFC107" title={list.status.description}/>
                )}
                {list.status.short_description === "PENDING" && (
                  <FontAwesomeIcon icon={faHourglass} color="#FFC107" title={list.status.description}/>
                )}
                {list.status.short_description === "WITHDRAWING" && (
                  <FontAwesomeIcon icon={faReply} color="#FFC107" title={list.status.description}/>
                )}
                {list.status.short_description === "REVERT" && (
                  <FontAwesomeIcon icon={faClose} color="#DC3545" title={"Leave Withdrawal Denied"}/>
                )}
              </td>
            </>
          )}
        </tr>
      ));
  };

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
        visible={loading}
        height="80"
        width="80"
        color="#4fa94d"
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
        }}
        />
      )}
      <Card className="CardContent">
        <h1 className="TitleHeader">Leave Approval</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <Table className="my-fixed-table" style={{ fontSize: "14px" }}>
          <thead>
            <tr>
              {isMobile ? (
                <>
                  <th style={{ width: "40px" }}>Approvals</th>
                  <th style={{ width: "10px" }} className="text-center align-middle">Status</th>
                </>
              ) : (
                <>
                  <th style={{ width: "40px" }}>Date Applied</th>
                  <th style={{ width: "90px" }}>Employee</th>
                  <th style={{ width: "50px" }}>Type</th>
                  <th style={{ width: "35px" }}>No. of Days</th>   
                  <th style={{ width: "65px" }}>Date</th>   
                  <th style={{ width: "100px" }}>Reason</th>
                  <th style={{ width: "20px" }} className="text-center align-middle">Status</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {lists.length > 0 ? (
              renderStaffList()
            ) : (
              <tr>
                {/* <td colSpan="6">No results found</td> */}
                <td colSpan={isMobile ? "2" : "7"}>No results found</td>
              </tr>
            )}
          </tbody>
        </Table>

        <div className="legend-pagination-row">
          <div className="legend-container">
            <div className="legend-row">
              <span className="legend-item2" style={{ color: "black" , fontSize: "14px" }}>
                <FontAwesomeIcon icon={faCheck} color="#28A744" />
                &nbsp;Approved
                &ensp;&ensp;&ensp;&ensp;&ensp;
                <FontAwesomeIcon icon={faReply} color="#28A744" />
                &nbsp;Withdrawn
                &ensp;&ensp;&ensp;&ensp;&ensp;
                <FontAwesomeIcon icon={faClose} color="#DC3545" />
                &nbsp;Rejected
                &ensp;&ensp;&ensp;&ensp;&ensp;
                <FontAwesomeIcon icon={faMinus} color="#FFC107" />
                &nbsp;Deleted
                &ensp;&ensp;&ensp;&ensp;&ensp;
                <FontAwesomeIcon icon={faHourglass} color="#FFC107" />
                &nbsp;Pending
              </span>
            </div>
          </div>

          <div
            style={{
              marginLeft: "auto",
              marginTop: isMobile ? "10px" : "0px"
            }}
          >
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handlePreviousPage={handlePreviousPage}
              handleNextPage={handleNextPage}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default LeaveApprovalList;
